import {
  LinkBox as ChakraLinkBox,
  LinkOverlay as ChakraLinkOverlay,
} from '@chakra-ui/react'

export const LinkBox = ChakraLinkBox
export const LinkOverlay = ChakraLinkOverlay
